module.exports = __webpack_public_path__ + "assets/img/u7 (1).72a369ae.png";